import { Schema } from '@core/data/dto/schema';

export const WorkplaceSchema = {
    id: Schema.String,
    name: Schema.String,
    address: Schema.Auto,
    primary: Schema.Boolean
}
